// extracted by mini-css-extract-plugin
export default {"heading":"heading--Vj0JJ","line":"line--etQ7Y"};